'use client';

import useSweeps from '@/application/sweeps/useSweeps';
import SweepHistoryTable from './SweepHistoryTable';
import { useChain } from '@/hooks/useChain';

const SweepHistoryTableContainer = ({}: {}) => {
  const { data: sweeps, status } = useSweeps();
  const chain = useChain();

  return <SweepHistoryTable chain={chain} sweeps={sweeps} status={status} />;
};

export default SweepHistoryTableContainer;
